/* eslint-disable no-console */
import Vue from "vue";
import VueRouter from "vue-router";
import children from "./ChildRoutes";
import { lsUtils } from "@/utils/localStorageUtils";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("@/App.vue"),
    children,
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Login.vue"),
  },
  {
    path: "/test-upload",
    name: "TestUpload",
    component: () => import("@/views/TestUpload.vue"),
  },
  {
    path: "/test-email",
    name: "TestEmail",
    component: () => import("@/views/TestSendEmail.vue"),
  },
  {
    path: "/test-editor",
    name: "TestEditor",
    component: () => import("@/views/TestingCKEditor.vue"),
  },
  {
    path: "/test-send-application",
    name: "TestSendApplication",
    component: () => import("@/views/TestSendEmailApplication.vue"),
  },
  {
    path: "/notfound",
    alias: "*",
    name: "NotFoundPage",
    component: () => import("@/views/NotFound.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, _, next) => {
  const userToken = lsUtils.getItem("userToken");
  if (to.path == "/login") {
    if (!userToken) {
      next();
    } else {
      next({ path: "/" });
    }
  } else {
    if (to.matched.some((r) => r.meta.requireAuth)) {
      if (!userToken) {
        next({ path: "/login" });
      } else {
        next();
      }
    } else {
      next();
    }
  }
});

export default router;
